import { useTranslation } from 'react-i18next';
import TickIcon from 'assets/icons/bigTick.svg';
import Header, { HeaderModifier } from 'components/header';
import IconList, { IconListModifier } from 'components/iconList';
import Marquee, { MarqueeItem } from 'components/marquee';

export interface PartnerHeaderProps {
  marqueeItems: MarqueeItem[];
}

function PartnerHeader(props: PartnerHeaderProps) {
  const { t } = useTranslation();
  const listData = [
    'Time-limited deals and discounts',
    'New offers will be added continuously',
    'Deals for Free, Pro, Expert, and Unlimited users',
  ].map((item: string) => t(item, { ns: 'partner' }));

  return (
    <div className="ct_partnerHeader">
      <div className="ct_partnerHeader-main">
        <div className="ct_partnerHeader-header">
          <Header
            title={t('Premium Benefits', { ns: 'partner' })}
            headline={t('Exclusive benefits with our Partners', { ns: 'partner' })}
            desc={t('As a CoinTracking user, you get access to exclusive deals and discounts with a variety of cryptocurrency services.', { ns: 'partner' })}
            modifiers={[HeaderModifier.NO_MARGIN]}
          />
        </div>
        <div className="ct_partnerHeader-list">
          <IconList icon={<TickIcon />} items={listData} modifiers={[IconListModifier.BIG]} />
        </div>
      </div>
      <div className="ct_partnerHeader-aside">
        {!!props.marqueeItems && !!props.marqueeItems.length && (
          <Marquee items={props.marqueeItems} duration={4} />
        )}
      </div>
    </div>
  );
}

PartnerHeader.defaultProps = { ...{} };

export default PartnerHeader;
